<template>
  <!-- 无数据页面 -->
  <div class="edit">
    <img style="width: 200px;" src="@/assets/img/no_data.png">
    <span style="color: #909AAE;font-size: 23px;">本页无数据</span>
  </div>
</template>

<script>
  export default {
    props: ['item', 'isEdit'],
    data() {
      return {}
    },
    mounted() {

    },
    methods: {}
  }
</script>

<style>
  .edit {
    width: 11.947rem;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/com/noData.vue